module.exports = __webpack_public_path__ + "img/movieTheater-3.c154e6f8.jpg";